import { encode, decode } from "helpers/secrets"

class Auth {}

Auth.setUserData = data => {
  var userData = {
    id:data.userData.user_id,
    token: data.tokenData.token,
    firstname: data.userData.user_data_id.first_name,
    lastname: data.userData.user_data_id.last_name,
    email: data.userData.user_data_id.email,
    user_type_code: data.userData.user_type_code,
    project_code: data.userData.project_code,
    dealer_code: data.userData.dealer_code,
    branch_name: (data && data.userData && data.userData.branch_name)?data.userData.branch_name:"Unknown Branch",
  }
  localStorage.setItem("uxd", encode(JSON.stringify(userData)))
}

Auth.getUserData = () => {
  let data = localStorage.getItem("uxd")
  var cData = null
  if (data && data !== "null" && data !== undefined) {
    cData = JSON.parse(decode(data))
  }
  return cData
}
Auth.getUserType = () => {
  let data = localStorage.getItem("uxd")
  var cData = null
  if (data) {
    cData = JSON.parse(decode(data)).user_type_code
  }
  return cData
}
Auth.getUserToken = () => {
  let data = localStorage.getItem("uxd")
  var cData = null
  if (data) {
    cData = JSON.parse(decode(data)).token
  }
  return cData
}
Auth.isAuthentication = () => {
  let status = false
  let data = localStorage.getItem("uxd")
  if (data) {
    return true
  }
  return status
}
Auth.destroyAuthentication = () => {
  localStorage.removeItem("uxd")
}

export default Auth
